import { library, config } from '@fortawesome/fontawesome-svg-core'

import {
    FontAwesomeIcon,
    FontAwesomeLayers,
} from '@fortawesome/vue-fontawesome'

import {
    faLinkedinIn,
    faFacebookF,
    faTwitter,
    faInstagram,
    faLinkedin,
} from '@fortawesome/free-brands-svg-icons'

import {
    faSignInAlt,
    faSignOutAlt,
    faSync,
    faCalendarDay,
    faCalendarWeek,
    faCalendarCheck,
    faThumbsUp,
    faThumbsDown,
    faNewspaper,
    faSortDown,
    faSort,
    faSearchMinus,
    faShareSquare,
    faUserEdit,
    faTrash,
    faTrashAlt,
    faEye,
    faExclamationTriangle,
    faExclamationCircle,
    faCheck,
    faCheckCircle,
    faRocket,
    faUnlink,
    faExternalLinkAlt,
    faDoorClosed,
    faRetweet,
    faChevronDown,
    faChevronRight,
    faLock,
    faUnlockAlt,
    faChevronUp,
    faReply,
    faChartLine,
    faChartBar,
    faPlus,
    faClock,
    faPause,
    faHammer,
    faPlay,
    faForward,
    faCog,
    faPuzzlePiece,
    faHistory,
    faPlug,
    faUserTimes,
    faBan,
    faSitemap,
    faClipboardList,
    faCaretUp,
    faCaretDown,
    faCaretRight,
    faLink,
    faVectorSquare,
    faArrowRight,
    faCrown,
    faKey,
    faUserTie,
    faPercent,
    faArrowCircleRight,
    faFileInvoice,
    faMicrophone,
    faBullseye,
    faQuoteLeft,
    faUserSecret,
    faUserShield,
    faTimesCircle,
    faArrowUp,
    faArrowLeft,
    faTasks,
    faAddressCard,
    faUserNinja,
    faBuilding,
    faBriefcase,
    faDollarSign,
    faUserFriends,
    faUnlock,
    faUserGraduate,
    faPodcast,
    faVolumeUp,
} from '@fortawesome/free-solid-svg-icons'

import {
    faBell,
    faHouse,
    faTrophyStar,
    faUser,
    faUsers,
    faBuildings,
    faUserTag,
    faUpRightFromSquare,
    faUserGroup,
    faRocketLaunch,
    faChartLineUp,
    faChartUser,
    faCloudArrowUp,
    faPersonRunning,
    faBars,
    faEnvelope,
    faUserCheck,
    faLightbulb,
    faCircleXmark,
    faCircleCheck,
    faTrashCheck,
    faBoxArchive,
    faBookOpenReader,
    faComments,
    faComment,
    faCircleTrash,
    faCircleStop,
    faCirclePause,
    faCirclePlay,
    faArrowDownToBracket,
    faArrowUpFromBracket,
    faCircleInfo,
    faCamera,
    faUserPlus,
    faEarthAmericas,
    faArrowRotateLeft,
    faArrowRotateRight,
    faMessage,
    faMessageDots,
    faPeopleGroup,
    faPencil,
    faFloppyDisk,
    faCircleUser,
    faPaperPlane,
    faCircleUp,
    faCircleDown,
    faThumbtack,
    faEllipsis,
    faXmark,
    faMonitorWaveform,
    faSquareRss,
    faRobot,
    faUserRobot,
    faUserPen,
    faWrench,
    faPaste,
    faFilePdf,
    faGrid2,
    faImage,
    faVideo,
    faLink as faLinkRegular,
    faFaceSmile,
    faHashtag,
    faTag,
    faCalendarClock,
    faGear,
    faFileExcel,
    faGhost,
    faFileLines,
    faChartPie,
    faChartArea,
    faUpload,
    faCalendar,
    faCalendars,
    faCalendarDays,
    faCalendarRange,
    faCircleQuestion,
    faPersonCircleQuestion,
    faListCheck,
    faChartSimple,
    faSpinner,
    faClock as faClockRegular,
    faImages,
    faAddressCard as faAddressCardRegular,
    faCircleChevronRight,
    faShareFromSquare,
    faHandHeart,
    faArrowLeft as faArrowLeftRegular,
    faPaperclip,
    faFile,
    faUserNinja as faUserNinjaRegular,
    faEye as faEyeRegular,
    faPenClip,
    faPercent as faPercentRegular,
    faTrophy,
    faMagnifyingGlass,
    faArrowTrendUp,
    faArrowRightArrowLeft,
} from '@fortawesome/pro-regular-svg-icons'

library.add(
    faBell,
    faCamera,
    faHouse,
    faTrophyStar,
    faUserPlus,
    faUserTag,
    faUser,
    faUsers,
    faBuildings,
    faUserGroup,
    faChartLineUp,
    faChartUser,
    faRocketLaunch,
    faUpRightFromSquare,
    faSignInAlt,
    faSignOutAlt,
    faSync,
    faCalendarDay,
    faCalendarWeek,
    faCalendarCheck,
    faThumbsUp,
    faThumbsDown,
    faNewspaper,
    faSortDown,
    faSort,
    faSearchMinus,
    faCloudArrowUp,
    faPersonRunning,
    faBars,
    faEnvelope,
    faUserCheck,
    faLightbulb,
    faCircleXmark,
    faCircleCheck,
    faTrashCheck,
    faBoxArchive,
    faShareSquare,
    faBookOpenReader,
    faUserEdit,
    faComments,
    faComment,
    faReply,
    faCircleTrash,
    faTrash,
    faTrashAlt,
    faEye,
    faExclamationTriangle,
    faExclamationCircle,
    faCircleStop,
    faCirclePause,
    faCirclePlay,
    faCheck,
    faCheckCircle,
    faArrowDownToBracket,
    faArrowUpFromBracket,
    faCircleInfo,
    faPeopleGroup,
    faRocket,
    faEarthAmericas,
    faUnlink,
    faExternalLinkAlt,
    faDoorClosed,
    faRetweet,
    faChevronDown,
    faLock,
    faUnlockAlt,
    faChevronUp,
    faChevronRight,
    faArrowRotateLeft,
    faArrowRotateRight,
    faMessage,
    faMessageDots,
    faChartLine,
    faChartBar,
    faPlus,
    faPencil,
    faFloppyDisk,
    faCircleUser,
    faCircleQuestion,
    faClock,
    faPause,
    faHammer,
    faPlay,
    faForward,
    faPaperPlane,
    faCircleUp,
    faCircleDown,
    faCog,
    faPuzzlePiece,
    faThumbtack,
    faEllipsis,
    faXmark,
    faMonitorWaveform,
    faSquareRss,
    faHistory,
    faPlug,
    faRobot,
    faUserRobot,
    faUserTimes,
    faBan,
    faUserPen,
    faSitemap,
    faClipboardList,
    faListCheck,
    faWrench,
    faPaste,
    faFilePdf,
    faLink,
    faGrid2,
    faImage,
    faVideo,
    faLinkRegular,
    faFaceSmile,
    faHashtag,
    faTag,
    faCalendarClock,
    faGear,
    faFileExcel,
    faCaretUp,
    faCaretDown,
    faCaretRight,
    faVectorSquare,
    faGhost,
    faArrowRight,
    faCrown,
    faPercent,
    faArrowCircleRight,
    faFileInvoice,
    faMicrophone,
    faBullseye,
    faFileLines,
    faChartPie,
    faChartArea,
    faChartSimple,
    faQuoteLeft,
    faUserSecret,
    faUserShield,
    faKey,
    faUpload,
    faTimesCircle,
    faCalendar,
    faCalendars,
    faCalendarDays,
    faCalendarRange,
    faUserTie,
    faPersonCircleQuestion,
    faSpinner,
    // New icons added for CSP migration
    faClockRegular,
    faImages,
    faAddressCardRegular,
    faCircleChevronRight,
    faShareFromSquare,
    faHandHeart,
    faArrowLeftRegular,
    faPaperclip,
    faFile,
    faUserNinjaRegular,
    faArrowUp,
    faArrowLeft,
    faTasks,
    faAddressCard,
    faUserNinja,
    faLinkedinIn,
    faFacebookF,
    faTwitter,
    faInstagram,
    faLinkedin,
    faBuilding,
    faBriefcase,
    faDollarSign,
    faUserFriends,
    faUnlock,
    faUserGraduate,
    faPodcast,
    faVolumeUp,
    faEyeRegular,
    faPenClip,
    faPercentRegular,
    faTrophy,
    faMagnifyingGlass,
    faArrowTrendUp,
    faArrowRightArrowLeft,
)

config.autoAddCss = false

export { FontAwesomeIcon, FontAwesomeLayers }
